import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';
import { RouterLink } from '@angular/router';
import { RootState } from '@next/core-lib/app';
import { TranslatePipe } from '@next/core-lib/i18n';
import { RouterSelectors } from '@next/core-lib/router-store';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-settings-navigation',
  templateUrl: 'settings-navigation.component.html',
  imports: [MatTabNav, MatTabLink, RouterLink, MatTabNavPanel, AsyncPipe, TranslatePipe],
})
export class SettingsNavigationComponent {
  routeUrl$: Observable<string> = this.store.pipe(select(RouterSelectors.getPath));

  isBarn$: Observable<boolean> = this.routeUrl$.pipe(map((url) => url.indexOf('barn') > 0));
  isObservationSetting$: Observable<boolean> = this.routeUrl$.pipe(
    map((url) => url.indexOf('observationsetting') > 0),
  );
  isRVSSetting$: Observable<boolean> = this.routeUrl$.pipe(
    map((url) => url.indexOf('rvssetting') > 0),
  );

  constructor(private readonly store: Store<RootState>) {}
}
